import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";

export const StandardVideoElementMixin = {
  extends: DynamicElementMixin,
};
